var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TopThreeRunners.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-748ffe41\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TopThreeRunners.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/LiveRun/Race/TopThreeRunners.vue
// module id = 1618
// module chunks = 2